var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-lab",
    transform: "translate(-719.919 -388.709)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 24,
    height: 24,
    transform: "translate(719.919 388.709)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M719.348-3255.17a2.414,2.414,0,0,1-2.17-1.341,2.415,2.415,0,0,1,.229-2.542l6.648-8.864v-4.373h-.786a1,1,0,0,1-1-1,1,1,0,0,1,1-1h9.179a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-.786v4.373l6.647,8.864a2.413,2.413,0,0,1,.229,2.541,2.413,2.413,0,0,1-2.171,1.342Zm-.341-2.683a.41.41,0,0,0-.04.447.41.41,0,0,0,.381.236h17.021a.412.412,0,0,0,.382-.236.411.411,0,0,0-.041-.447l-4.408-5.877h-8.887Zm11.8-7.877-1.14-1.52v-5.04h-3.607v5.04l-1.14,1.52Z",
    transform: "translate(4.061 3665.25)",
    fill: "#222a41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTest);
export default __webpack_public_path__ + "static/media/icon_test.73473682.svg";
export { ForwardRef as ReactComponent };